import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import QAUpload from '../../container/modules/qa/QAUpload.js';

const NotFound = lazy(() => import('../../container/pages/404.js'));
const Profile = lazy(() => import('../../container/modules/profile/index.js'));
const UploadAndEncoding = lazy(() => import('../../container/modules/uploads/UploadsEncoding.js'));
const Encoding = lazy(() => import('../../container/modules/uploads/Encoding.js'));
const UploadDocumentList = lazy(() => import('../../container/modules/uploads/List.js'));
const UploadBatchHeader = lazy(() => import('../../container/modules/uploads/BatchHeader.js'));
const UploadFiles = lazy(() => import('../../container/modules/uploads/Files.js'));
const Search = lazy(() => import('../../container/modules/search/Search.js'));
const SearchView = lazy(() => import('../../container/modules/search/SearchView.js'));
const HQView = lazy(() => import('../../container/modules/search/HQView.js'));
const GroupView = lazy(() => import('../../container/modules/search/GroupView.js'));
const BatchControlView = lazy(() => import('../../container/modules/search/BatchControlView.js'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="profile" element={<Profile />} />
      <Route path="upload" element={<UploadAndEncoding />} />
      <Route path="encoding" element={<Encoding />} />
      <Route path="upload/batch-header" element={<UploadBatchHeader />} />
      <Route path="upload/files" element={<UploadFiles />} />
      <Route path="search" element={<Search />} />
      <Route path="search/view" element={<SearchView />} />
      <Route path="search/hq-search/view" element={<HQView />} />
      <Route path="search/group-search/view" element={<GroupView />} />
      <Route path="search/batch-control/view" element={<BatchControlView />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default PagesRoute;
